(ns teamoesterreich.admin-mode.data.webHelpText
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))


(defn >webBlog-edit [webBlog-uuid webBlog finished-fn]
  (ajax/auth-put> (backend/get-auth) (str  backend/BASE_URL "/webHelpTexts/" webBlog-uuid)
             (ajax/serialize (merge webBlog
                                    {:webHelpText-uuid webBlog-uuid}))
             finished-fn))

(defn get-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/webHelpTexts")
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (map (fn [e] [(get e "webHelpText-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                    )))))

(defn get-entry [blockUuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/webHelpTexts/" blockUuid)
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                    )))))

(defn get-entry-by-page [page done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/webHelpTexts/by-page/" page)
              (fn [r-list status]
                ;(log/debug "get-blog done" r-list status)
                (when (= status 200)
                  (done-fn
                    (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                    )))))
